const REGION_NAME_OVERRIDES: Record<string, string> = {
  HK: "香港",
  TW: "台灣",
  CN: "中國大陸",
  MO: "澳門",
  US: "美國",
  CA: "加拿大",
  GB: "英國",
  AU: "澳洲",
  JP: "日本",
  KR: "南韓",
  SG: "新加坡",
  MY: "馬來西亞",
  TH: "泰國",
  PH: "菲律賓",
  ID: "印尼",
  VN: "越南",
  IN: "印度",
  FR: "法國",
  DE: "德國",
  IT: "意大利",
  ES: "西班牙",
  NL: "荷蘭",
  T1: "Tor 網絡"
};

const regionDisplayNames =
  typeof Intl.DisplayNames === "function" ? new Intl.DisplayNames(["zh-Hant-HK", "zh-Hant"], { type: "region" }) : null;

function lookupChineseRegionName(code: string): string {
  if (REGION_NAME_OVERRIDES[code]) return REGION_NAME_OVERRIDES[code];
  if (!/^[A-Z]{2}$/.test(code) || !regionDisplayNames) return "";

  try {
    const name = regionDisplayNames.of(code);
    return name && name !== code ? name : "";
  } catch {
    return "";
  }
}

export function formatRegionLabel(region: string): string {
  const code = region.trim().toUpperCase();
  if (!code || code === "UNKNOWN") return "Unknown 未知";

  const chineseName = lookupChineseRegionName(code);
  return chineseName ? `${code} ${chineseName}` : code;
}
